module.exports = {"TXTWCL_Account_details":{"id":"TXTWCL_Account_details","defaultMessage":"Данные учетной записи"}}